import './ShareLinkCard.scss'

import { CheckboxChangePayload } from '@here/hds-components'
import { HDSToggle } from '@here/hds-react-components'
import classNames from 'classnames'
import CopyLink from 'components/CopyLink'
import { i18n } from 'lib/i18n'
import React, { useCallback } from 'react'
import QRCode from 'react-qr-code'

export interface ShareLinkCardProps {
  url: string
  isGuidanceVisible?: boolean
  isGuidanceEnabled?: boolean
  isGuidanceChecked?: boolean
  className?: string
  onShare: (url: string) => void
  onGuidanceToggle?: (checked: boolean) => void
}

export default function ShareLinkCard({
  url,
  className,
  isGuidanceVisible = false,
  isGuidanceChecked,
  isGuidanceEnabled = true,
  onShare,
  onGuidanceToggle,
}: ShareLinkCardProps): JSX.Element {
  const handleGuidanceToggle = useCallback(
    (payload: CheckboxChangePayload): void => {
      isGuidanceEnabled && onGuidanceToggle && onGuidanceToggle(payload.checked)
    },
    [isGuidanceEnabled, onGuidanceToggle]
  )

  return (
    <div className={classNames('ShareLinkCard', className)}>
      {isGuidanceVisible && (
        <div className="ShareLinkCard__guidance">
          <div className="ShareLinkCard__guidance-content">
            <div className="ShareLinkCard__guidance-title">
              {i18n('share.share-route-card.open-in-guidance')}
            </div>
            <div className="ShareLinkCard__guidance-description">
              {i18n('share.share-route-card.open-in-guidance-description')}
            </div>
          </div>
          <div className="ShareLinkCard__guidance-toggle-button">
            <HDSToggle
              onCheck={handleGuidanceToggle}
              disabled={!isGuidanceEnabled}
              checked={isGuidanceChecked}
            />
          </div>
        </div>
      )}
      <CopyLink className="ShareLinkCard__share-link" url={url} onCopy={onShare} />
      <div className="ShareLinkCard__divider" />
      <div className="ShareLinkCard__qrCode">
        <QRCode
          value={url}
          size={160}
          viewBox={`0 0 160 160`}
          style={{ height: 'auto', maxWidth: '100%', width: '100%' }}
        />
        <div className="ShareLinkCard__qrCode-description">
          {i18n('share.share-route-card.qr-code')}
        </div>
      </div>
    </div>
  )
}
